// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__13Sqf","vertical":"HomePage_vertical__THcCO"};